import { render, staticRenderFns } from "./PrivateWall.vue?vue&type=template&id=2cc9c5b7&scoped=true"
import script from "./PrivateWall.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivateWall.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PrivateWall.vue?vue&type=style&index=0&id=2cc9c5b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc9c5b7",
  null
  
)

export default component.exports